import React, { useContext, useEffect, useState } from 'react';
import { DonutChart, DonutChartItem } from "react-charts";
import { CampaignContext, MStatus } from './campaign-context';
import { groupBy, sleep, sum } from 'simple-utils';
import { getStyle, getLabel } from '../bots/message-chart-loader';

function donutTooltip(item:DonutChartItem, setup: any){
    return <>
        <div className="mb-2">
           <b> {item.label} </b> <br />
         <b className={`${item.style} bg-color badge` }>{(item.value / setup.total * 100).toFixed(1) + "%"}</b></div>
        <div className="">{item.value} Mensagens</div>
    </>
}

function messageStatusToChart(s:MStatus):DonutChartItem[]{
    const g = groupBy(Object.values(s), m => m.groupName);
    const result:DonutChartItem[] = []
    Object.entries(g).forEach(([k, e]) => {
        result.push({label: getLabel(k), style: getStyle(k), value: e.length});
    });

    return result;
}

export function MessageStatusChart(){
    const {state:{messageStatus}} = useContext(CampaignContext);
    const [data, setData] = useState<DonutChartItem[]>(null);
    useEffect(() => {
        (async function(){
            await sleep(1000);
            setData(messageStatusToChart(messageStatus));
        })()
    }, [messageStatus]);
    
    
    if(data == null) return <div className="text-muted"><i className="fa fa-spin fa-circle-notch"></i> Carregando...</div>;

    const count = sum(Object.values(data), a => a.value);

    return <>
        <p><b>{count}</b> mensagens enviadas</p>
        <DonutChart className='mt-4 d-sm-flex align-items-center' data={data} height={180} width={192} radius={55} thickness={20} textRadiusOffset={80} createTooltip={donutTooltip} />
    </>
}